var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4612 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M4612 36h12v21h-12z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ChevronRight_svg__a",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4282-356h360v740h-360z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ChevronRight_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4282-356h360v740h-360z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ChevronRight_svg__b",
    fill: "transparent",
    transform: "translate(4282 -47)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ChevronRight_svg__c",
    fill: "transparent",
    transform: "translate(4608 38)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ChevronRight_svg__d",
    fill: "currentColor",
    transform: "translate(4614 38)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ChevronRight_svg__b",
    d: "M0 0h360v463H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ChevronRight_svg__c",
    d: "M0 0h19v19H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ChevronRight_svg__d",
    d: "m8.5 8.5 1.06 1.06a1.5 1.5 0 0 0 0-2.12zm-9.56-7.44 8.5 8.5 2.12-2.12-8.5-8.5zm8.5 6.38-8.5 8.5 2.12 2.12 8.5-8.5z"
  }))));
};
export default SvgChevronRight;